import { render } from "./ProcurementLayout.vue?vue&type=template&id=ff0b20fc&scoped=true"
import script from "./ProcurementLayout.vue?vue&type=script&lang=js"
export * from "./ProcurementLayout.vue?vue&type=script&lang=js"

import "./ProcurementLayout.vue?vue&type=style&index=0&id=ff0b20fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0b20fc"]])

export default __exports__